import React from 'react';

const baseStyles =
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-400 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ring-offset-white';

const variants = {
  default: 'bg-stone-900 text-white hover:bg-stone-800',
  secondary: 'bg-stone-100 text-stone-900 hover:bg-stone-200',
  outline: 'border border-stone-300 bg-white text-stone-900 hover:bg-stone-100',
  ghost: 'text-stone-700 hover:bg-stone-100 hover:text-stone-900',
};

const sizes = {
  default: 'h-10 px-4 py-2',
  sm: 'h-9 rounded-md px-3',
  lg: 'h-11 rounded-md px-8',
  icon: 'h-10 w-10',
};

function Button({
  className = '',
  variant = 'default',
  size = 'default',
  asChild = false,
  children,
  ...props
}) {
  const Component = asChild ? 'span' : 'button';
  const variantStyles = variants[variant] || variants.default;
  const sizeStyles = sizes[size] || sizes.default;
  const classes = [baseStyles, variantStyles, sizeStyles, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
}

export default Button;
